import type { BookingStatus, RangeKey, StatusFilterKey } from '../../../types/provider';

export const PAGE_SIZE = 20;

/**
 * Status visual config (color + antd preset).
 * Display label is resolved via i18n: `provider:bookings.statusLabels.<status>`
 */
export const STATUS_CONFIG: Record<
  BookingStatus,
  { color: string; antColor: string }
> = {
  PENDING: { color: '#faad14', antColor: 'warning' },
  CONFIRMED: { color: '#1677ff', antColor: 'processing' },
  COMPLETED: { color: '#52c41a', antColor: 'success' },
  CANCELED_BY_USER: { color: '#ff4d4f', antColor: 'error' },
  CANCELED_BY_SERVICE_PROVIDER: { color: '#ff4d4f', antColor: 'error' },
  EXPIRED: { color: '#8c8c8c', antColor: 'default' },
  REFUND_REQUESTED: { color: '#fa8c16', antColor: 'warning' },
  REVERSED_OK: { color: '#8c8c8c', antColor: 'default' },
  NO_SHOW: { color: '#8c8c8c', antColor: 'default' },
};

/** Range option keys — labels resolved via i18n: `provider:bookings.rangeOptions.<key>` */
export const RANGE_VALUES: RangeKey[] = ['today', 'week', 'month'];

/** Status filter chip keys — labels resolved via i18n: `provider:bookings.statusFilters.<key>` */
export const STATUS_FILTER_VALUES: StatusFilterKey[] = [
  'ALL',
  'PENDING',
  'CONFIRMED',
  'COMPLETED',
  'CANCELED_BY_USER',
  'CANCELED_BY_SERVICE_PROVIDER',
];
